const WeightLossForm = document.getElementById('weight-loss-calculator');
const closeCal = document.getElementById('weight-loss-calculator-close');

WeightLossForm.addEventListener('submit', function(event) {
    event.preventDefault();

    const height = parseFloat(document.getElementById('height').value);
    const age = parseInt(document.getElementById('age').value);
    const weight = parseFloat(document.getElementById('weight').value);
    const target = parseFloat(document.getElementById('target').value);
    const actLevel = parseFloat(document.querySelector('input[name="actlevel"]:checked').value);
    const gender = parseFloat(document.querySelector('input[name="gender"]:checked').value);

    const bmr = (weight * 10) + (height * 6.25) - (5 * age) + gender;
    const tdee = bmr * actLevel;
    const dailyDiff = Math.round(tdee - 800);
    const noOfDays = Math.round((target * 7000) / dailyDiff);

    document.querySelector("#update-number").textContent = noOfDays.toString();

    if (window.innerWidth < 750){

    }

    document.querySelectorAll(".weight-loss-calculator-container-result>span, .weight-loss-calculator-container-result>a").forEach(el => el.classList.add('hidden'));

    document.querySelector('.weight-loss-calculator-container-result').classList.remove('hidden');
    document.querySelector(".circuit-graphic .circle:last-child").classList.add('active');

    const ranges = [
        { max: 10, className: 'weight-loss-elem-1' },
        { min: 11, max: 14, className: 'weight-loss-elem-2' },
        { min: 15, max: 21, className: 'weight-loss-elem-3' },
        { min: 22, className: 'weight-loss-elem-4' },
    ];

    ranges.forEach(range => {
        if ((range.min === undefined || noOfDays >= range.min) && (range.max === undefined || noOfDays <= range.max)) {
            document.querySelectorAll(`.${range.className}`).forEach(el => el.classList.remove('hidden'));
        }
    });
});

closeCal.addEventListener('click', function(event) {
    document.querySelector('.weight-loss-calculator-container-result').classList.add('hidden');

});

